import { DashboardIcon, LineIcon, MakerIcon, MapIcon } from "@/assets/icons";
import { SPATIAL_AGGREGATION_NAME } from "@/constants/dataset";
import { ExtendedSpatialAggregationType } from "@/types/common";
import { EOutputAnalysisType } from "@/types/spatial";

interface AggregationConfig {
  icon?: JSX.Element;
  bgColor: string;
  label?: string;
}

interface AggregationBadgeProps {
  value?:
    | Exclude<ExtendedSpatialAggregationType, EOutputAnalysisType>
    | null
    | "";
}

const aggregationStyles: Record<
  Exclude<ExtendedSpatialAggregationType, EOutputAnalysisType>,
  AggregationConfig
> = {
  poi: {
    icon: <MakerIcon width={16} height={16} />,
    bgColor:
      "fill-purple-700 bg-purple-50 border border-purple-200 text-purple-700"
  },
  polygon: {
    icon: <DashboardIcon width={16} height={16} />,
    bgColor:
      "fill-orange-700 bg-orange-50 border border-orange-200 text-orange-700"
  },
  adm_area: {
    icon: <MapIcon width={16} height={16} />,
    bgColor: "fill-blue-700 bg-blue-50 border border-blue-200 text-blue-700"
  },
  H3: {
    icon: <DashboardIcon width={16} height={16} />,
    bgColor:
      "fill-orange-700 bg-orange-50 border border-orange-200 text-orange-700"
  },
  geohash: {
    icon: <DashboardIcon width={16} height={16} />,
    bgColor:
      "fill-orange-700 bg-orange-50 border border-orange-200 text-orange-700"
  },
  line: {
    icon: <LineIcon width={16} height={16} className="fill-[#AF6306]" />,
    bgColor: "bg-orange-50 border border-orange-200 text-[#AF6306]"
  },
  // DEFAULT STATE
  default: {
    bgColor: "bg-neutral-50 border border-neutral-100 text-neutral-300",
    label: "None"
  }
};

export default function AggregationBadge({
  value
}: Readonly<AggregationBadgeProps>) {
  const isValid =
    value !== null &&
    value !== undefined &&
    value !== "" &&
    value !== "default" &&
    aggregationStyles[value];

  const config = isValid
    ? aggregationStyles[value]
    : aggregationStyles["default"];

  const label = isValid
    ? SPATIAL_AGGREGATION_NAME[value as keyof typeof SPATIAL_AGGREGATION_NAME]
    : config.label;

  return (
    <span
      className={`inline-flex items-center gap-1 py-1 px-2 rounded-lg font-semibold text-xs ${config.bgColor}`}
    >
      <span>{config.icon}</span>
      <span>{label}</span>
    </span>
  );
}
